import * as React from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { SpinnerButton } from 'src/components/molecules/SpinnerButton';
import { AccountType } from 'src/types';
import {
  BackButton,
  ButtonWrapper,
  Description,
  HeaderLeft,
  HeaderMid,
  HeaderRight,
  HeaderWrapper,
  InputContainer,
  LoginContainerBody,
  LoginContainerWrapper,
  LogoContainer,
  StyledHeader,
} from './LoginContainer.styles';

interface Props {
  children?: React.ReactNode;
  header?: string;
  backButtonOnClick?(): void;
  description?: string;
  includeForm?: boolean;
  buttonText?: string;
  buttonDisabled?: boolean;
  buttonOnClick?(): void;
  'data-testid'?: string;
  loading?: boolean;
  kind?: AccountType.App | AccountType.Portal;
}

const LoginContainer = ({ header, description, kind, ...props }: Props) => (
  <LoginContainerWrapper>
    <LoginContainerBody>
      {kind !== AccountType.App && (
        <LogoContainer>
          <img
            src="/assets/Diligent-favicon.svg"
            alt="Diligent"
            width={25}
            height={25}
          />
          <StyledHeader>Resolution Hub</StyledHeader>
        </LogoContainer>
      )}
      <InputContainer>
        {header && (
          <HeaderWrapper>
            {props.backButtonOnClick ? (
              <>
                <HeaderLeft>
                  <BackButton onClick={props.backButtonOnClick}>
                    <StyledIcon className="uil uil-arrow-left" size="24px" />
                  </BackButton>
                </HeaderLeft>
                <HeaderMid>{header}</HeaderMid>
                <HeaderRight></HeaderRight>
              </>
            ) : (
              <HeaderMid>{header}</HeaderMid>
            )}
          </HeaderWrapper>
        )}
        {description && <Description>{description}</Description>}
        {props.includeForm ? (
          <form className="formContainer">
            {props.children}
            <ButtonWrapper>
              <SpinnerButton
                variant="primary"
                size="medium"
                data-testid={props['data-testid'] || ''}
                onClick={() => {
                  props.buttonOnClick && props.buttonOnClick();
                }}
                disabled={props.buttonDisabled ?? false}
                width="100%"
                loading={props.loading}
              >
                {props.buttonText || ''}
              </SpinnerButton>
            </ButtonWrapper>
          </form>
        ) : (
          <div>{props.children}</div>
        )}
      </InputContainer>
    </LoginContainerBody>
  </LoginContainerWrapper>
);

export default LoginContainer;
